var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDealzy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 240,
    viewBox: "0 0 240 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 240,
    fill: "#BBDEFB",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.967 0C71.38 0 83.621 2.2325 94.689 6.6975C105.757 11.1625 115.301 17.6014 123.321 26.0144C131.34 34.4274 137.508 44.5793 141.822 56.4703C146.135 68.3546 148.294 84.3779 148.296 99.138C148.296 99.138 148.296 97.158 148.296 97.158C148.296 97.158 119.691 73.094 119.691 73.094C119.043 69.4689 118.211 68.2229 117.2 64.9302C114.386 55.7653 110.259 48.0103 104.819 41.6653C99.379 35.3204 92.743 30.5029 84.911 27.2129C77.078 23.9229 68.097 22.2779 57.967 22.2779C57.967 22.2779 27.1545 22.2779 27.1545 22.2779L27.1537 51.4366L0 74.2974L0 0C0 0 57.967 0 57.967 0Z",
    fill: "#136EF3",
    transform: "translate(59.027 14)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 94.751C0 94.751 27.155 72.363 27.155 72.363C27.155 72.363 35.424 72.363 35.424 72.363C50.057 72.363 62.251 69.285 72.005 63.128C81.76 56.971 89.1 48.323 94.024 37.184C98.949 26.045 101.411 15.008 101.411 0.0620041C101.411 0.0620041 101.411 0 101.411 0C101.411 0 126.064 21.557 126.064 21.557C125.545 26.289 126.127 26.28 121.812 38.171C117.497 50.062 111.283 60.19 103.17 68.556C95.056 76.922 85.301 83.338 73.905 87.803C62.508 92.268 49.682 94.5 35.424 94.5C35.424 94.5 5.5065 94.5 5.5065 94.5C5.5065 94.5 0 94.751 0 94.751Z",
    fill: "#136EF3",
    transform: "translate(79.038 125.296)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0C0 0 16.0082 0 16.0082 0L16.0082 115.01L0 122.325C0 122.325 0 0 0 0Z",
    fill: "#061E4A",
    fillRule: "evenodd",
    transform: "translate(59.027 96.218)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 95.336C0 95.336 113.5 0 113.5 0L122 11.5L10.2482 107.636C10.2482 107.636 0 95.336 0 95.336Z",
    fill: "#061E4A",
    fillRule: "evenodd",
    transform: "translate(6 45)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 46.1669C0 46.1669 54.913 1.90735e-05 54.913 1.90735e-05L65.161 12.2996L10.2482 58.4669C10.2482 58.4669 0 46.1669 0 46.1669Z",
    fill: "#9FA8C7",
    fillRule: "evenodd",
    transform: "translate(64.932 44.035)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.4888 54.411C2.4888 54.411 66.9976 0 66.9976 0L77.2466 12.299L11.934 66.117L0 66.18L0.0241013 55.999C0.0241013 55.999 2.4888 54.411 2.4888 54.411Z",
    fill: "#061E4A",
    fillRule: "evenodd",
    transform: "translate(59.163 153.325)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 12.1383C0 12.1383 113.988 110.211 113.988 110.211L124.419 98.0729L10.43 0C10.43 0 0 12.1383 0 12.1383Z",
    fill: "#9FA8C7",
    fillRule: "evenodd",
    transform: "translate(108.59 43.312)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDealzy);
export default __webpack_public_path__ + "static/media/dealzy.38dc0685ef05bdd37d35d86fe282ca52.svg";
export { ForwardRef as ReactComponent };